import type { FC, ReactNode, Ref } from 'react';

type Props = {
  title?: ReactNode;
  subtitle?: ReactNode;
  icon?: ReactNode;
  headExtra?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  bodyClassName?: string;
  scrollClassName?: string;
  scrollRef?: Ref<HTMLDivElement>;
  compact?: boolean;
  frameless?: boolean;
};

export const IpcTablePanel: FC<Props> = ({
  title,
  subtitle,
  icon,
  headExtra,
  children,
  footer,
  className,
  bodyClassName,
  scrollClassName,
  scrollRef,
  compact = false,
  frameless = false,
}) => {
  const hasHeader = title != null || subtitle != null || icon != null || headExtra != null;

  return (
    <>
      <div
        className={[
          'ipc-table-panel',
          compact ? 'ipc-table-panel--compact' : '',
          frameless ? 'ipc-table-panel--frameless' : '',
          className,
        ].filter(Boolean).join(' ')}
      >
        {hasHeader && (
          <div className="ipc-table-panel__head">
            <div className="ipc-table-panel__title-wrap">
              {icon != null && <span className="ipc-table-panel__icon" aria-hidden>{icon}</span>}
              {title != null && <span className="ipc-table-panel__title">{title}</span>}
              {subtitle != null && <span className="ipc-table-panel__subtitle">{subtitle}</span>}
            </div>
            {headExtra != null && <span className="ipc-table-panel__head-extra">{headExtra}</span>}
          </div>
        )}
        <div className={['ipc-table-panel__body', bodyClassName].filter(Boolean).join(' ')}>
          <div ref={scrollRef} className={['ipc-table-panel__scroll', scrollClassName].filter(Boolean).join(' ')}>
            {children}
          </div>
        </div>
      </div>
      {footer}
    </>
  );
};
